export default __webpack_public_path__ + "static/media/premium-tactic.bd52b282.jpg";